export default __webpack_public_path__ + "static/media/filledhole.c82c9659.png";